// extracted by mini-css-extract-plugin
var _1 = "styles-module__body___SaYlv";
var _2 = "styles-module__photoFeed___roFWw";
var _3 = "styles-module__reviews___b3cjy";
var _4 = "styles-module__reviewsContainer___IcL0l";
var _5 = "styles-module__section___QIUHj";
export { _1 as "body", _2 as "photoFeed", _3 as "reviews", _4 as "reviewsContainer", _5 as "section" }
